import { render, staticRenderFns } from "./ordersType.vue?vue&type=template&id=5234fe9f&"
import script from "./ordersType.vue?vue&type=script&lang=js&"
export * from "./ordersType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports